import { render, staticRenderFns } from "./RowBlockPromoCodeDiscount.vue?vue&type=template&id=3c986872&"
import script from "./RowBlockPromoCodeDiscount.vue?vue&type=script&lang=js&"
export * from "./RowBlockPromoCodeDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports